export enum HeaderMessageType {
  Success = 'HEADER_MESSAGE_TYPE.WELL_DONE',
  Error = 'HEADER_MESSAGE_TYPE.ERROR',
  Info = 'HEADER_MESSAGE_TYPE.SYSTEM_INFO',
  Warning = 'HEADER_MESSAGE_TYPE.WARNING'
}
